import React, { ReactElement, useEffect, useState } from 'react';
import apiRoutes from '../../../config/api/routes';
import { useFetch } from '../../shared';
import { PageTitle, PublicPageWrapper } from '../../shared/components';
import PublicPageSettingsProvider from './PublicPageSettingsProvider';
import { createGlobalStyle, ThemeProvider as SCThemeProvider } from 'styled-components';
import { StylesProvider, ThemeProvider } from '@material-ui/styles';
import theme from '../../../config/theme';
import { CssBaseline } from '@material-ui/core';
import BackendHealthCheckErrorMessage from './BackendHealthCheckErrorMessage';

type Props = {
  children: ReactElement | null;
};

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 62.5%;
  }
  html,
  body,
  #root {
    height: 100%;
    overflow: hidden;
  }
`;

const BackendHealthCheck = ({ children }: Props) => {
  const [backendIsOnline, setBackendIsOnline] = useState(false);
  const [backendOnlineResponse, backendOnline] = useFetch(apiRoutes.ping());

  useEffect(() => {
    if (backendOnlineResponse.initial) backendOnline();
  }, [backendOnline, backendOnlineResponse]);

  useEffect(() => {
    if (backendOnlineResponse.success) setBackendIsOnline(true);
  }, [backendOnlineResponse]);

  if (backendOnlineResponse.initial || backendOnlineResponse.pending) return null;

  return backendIsOnline ? (
    children
  ) : (
    <SCThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <PublicPageSettingsProvider>
          <StylesProvider injectFirst>
            <CssBaseline />
            <GlobalStyle />
            <PublicPageWrapper backendOnline={false} excludeFooter>
              <PageTitle>We kunnen je nu niet aanmelden</PageTitle>
              <BackendHealthCheckErrorMessage />
            </PublicPageWrapper>
          </StylesProvider>
        </PublicPageSettingsProvider>
      </ThemeProvider>
    </SCThemeProvider>
  );
};

export default BackendHealthCheck;
